import React from 'react';

const Photos360Legacy = ({siteID}) =>  {
    const vtourUrl= '/storage/sites/'+siteID+'/images360/vtour/tour.html';
    const vtourUrlBase = '/storage/sites/'+siteID+'/images360/vtour/';
    return (
        <div className="homepage-wrapper images360-wrapper">
            <div className="fullscreen-wrapper">
                <iframe src={vtourUrl + '?base=' + vtourUrlBase} marginHeight="0" marginWidth="0" frameBorder="0" scrolling="no"
                        style={{width: '100%', height: '100%'}} allowFullScreen={true} mozallowfullscreen="true"
                        webkitallowfullscreen="true" className="pp-embed-content"></iframe>
                <noscript>&lt;div class="pp-error-msg"&gt;&lt;strong&gt;Error&lt;/strong&gt;&lt;br/&gt;Javascript not
                    activated&lt;/div&gt;</noscript>
            </div>
        </div>
    )
}

export default Photos360Legacy;
